import React, {FC, useEffect, useState} from "react"
import braze from "@irati/braze/services/braze"
import authentication from "@irati/auth"
import {ClassicCard} from "@irati/braze/services/sdk"
import DesktopMenu from "../desktop/DesktopMenu"
import NotificationBell from "../shared/Notifications/NotificationBell"
import ContentCardsContainer from "../shared/Notifications/ContentCardsContainer"

const DesktopNotificationMenu: FC = () => {
  const [isMenuDisplayed, setIsMenuDisplayed] = useState<boolean>(false)
  const [contentCards, setContentCards] = useState<ClassicCard[]>([])

  useEffect(() => {
    if (authentication.isUserGhost()) return

    braze.setUserId(authentication.user().uuid!).then(() => {
      const result = braze.getContentCards()
      setContentCards(result)
    })
  }, [])

  const handleMenuClicked = (value?: boolean) => {
    setIsMenuDisplayed((current) => value !== undefined ? value : !current)
    braze.markCardsAsSeen(contentCards)
  }

  if (authentication.isUserGhost()) return null

  return (
    <DesktopMenu
      tooltip="Notification Center"
      onOutsideClick={() => setIsMenuDisplayed(false)}
      onClick={handleMenuClicked}
      content={<ContentCardsContainer cards={contentCards} />}>
      <NotificationBell isDisplayed={isMenuDisplayed} count={contentCards.filter((card) => !card.viewed).length} />
    </DesktopMenu>
  )
}


export default DesktopNotificationMenu
